import React from "react";

export const GuestsCell = ({
  adultsCount,
  childrenCount,
}: {
  adultsCount: number;
  childrenCount: number;
}) => (
  <div className="text-sm text-center">
    {!!adultsCount && <div>Adults: {adultsCount}</div>}
    {!!childrenCount && <div>Children: {childrenCount}</div>}
  </div>
);
